import { formDataApi } from 'api/api';

export const modifyLCRecordsDetails = async (formData) => {
  const response = await formDataApi.post(`restEmpIndex/modifyLifeCycleCaseRecord`, formData);
  return response?.data;
};
